/**
 * slice
 */

var slice = Array.prototype.slice

/**
 * Primary export
 */

var exports = module.exports = super_

/**
 * ### _super (dest, orig)
 *
 * Inherits the prototype methods or merges objects.
 * This is the primary export and it is recommended
 * that it be imported as `inherits` in node to match
 * the auto imported browser interface.
 *
 *     var inherits = require('super')
 *
 * @param {Object|Function} destination object
 * @param {Object|Function} source object
 * @name _super
 * @api public
 */

function super_ () {
  var args = slice.call(arguments)
  if (!args.length) return
  if (typeof args[0] !== 'function') return exports.merge(args)
  exports.inherits.apply(null, args)
}

/**
 * ### extend (proto[, klass])
 *
 * Provide `.extend` mechanism to allow extenion without
 * needing to use dependancy.
 *
 *     function Bar () {
 *       this._konstructed = true
 *     }
 *
 *     Bar.extend = inherits.extend
 *
 *     var Fu = Bar.extend({
 *       initialize () {
 *         this._initialized = true
 *       }
 *     })
 *
 *     var fu = new Fu()
 *     fu.should.be.instanceof(Fu) // true
 *     fu.should.be.instanceof(Bar) // true
 *
 * @param {Object} properties/methods to add to new prototype
 * @param {Object} properties/methods to add to new class
 * @returns {Object} new constructor
 * @name extend
 * @api public
 */

exports.extend = function (proto, klass) {
  var self = this
  var child = function () { return self.apply(this, arguments) }
  exports.merge([ child, this ])
  exports.inherits(child, this)
  if (proto) exports.merge([ child.prototype, proto ])
  if (klass) exports.merge([ child, klass ])
  child.extend = this.extend // prevent overwrite
  return child
}

/**
 * ### inherits (ctor, superCtor)
 *
 * Inherit the prototype methods from on contructor
 * to another.
 *
 * @param {Function} destination
 * @param {Function} source
 * @api private
 */

exports.inherits = function (ctor, SuperCtor) {
  ctor.super_ = SuperCtor
  if (Object.create) {
    ctor.prototype = Object.create(SuperCtor.prototype,
      {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
  } else {
    ctor.prototype = new SuperCtor()
    ctor.prototype.constructor = ctor
  }
}

/**
 * Extends multiple objects.
 *
 * @param {Array} array of objects
 * @api private
 */

exports.merge = function (arr) {
  var main = arr.length === 2 ? arr.shift() : {}
  var obj = null

  for (var i = 0, len = arr.length; i < len; i++) {
    obj = arr[i]
    for (var p in obj) {
      if (!obj.hasOwnProperty(p)) continue
      main[p] = obj[p]
    }
  }

  return main
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/range/range/lib/lib/super.js